/* SD2 27 Oct (EGF toner, collakor 1:1): add-to-cart text shows the price of the selected Kaching bar ("AJOUTER AU PANIER - 119,98 €"),
   follows bar + subscription/one-time changes. Leaves other button states (sold out, adding) alone. */
(function () {
  var BASE = /^ajouter au panier/i;
  function btnSpan() {
    var b = document.querySelector('form[action*="/cart/add"] .product-form__submit');
    return b && !b.disabled ? b.querySelector('span') : null;
  }
  function price() {
    var p = document.querySelector('kaching-bundles-block .kaching-bundles__bar--selected .kaching-bundles__bar-price');
    return p ? p.textContent.trim() : '';
  }
  function apply() {
    var s = btnSpan(), p = price();
    if (!s || !p || !BASE.test(s.textContent.trim())) return;
    var want = 'Ajouter au panier - ' + p;
    if (s.textContent.trim() !== want) s.textContent = want;
  }
  var queued = false;
  function soon() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; apply(); }); }
  function start() {
    apply();
    new MutationObserver(soon).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
